/*
  <look-hotspots>: product hotspots on a "Shop the look" image.
  A hotspot button shows its product card; only one card is open at a time.
  Clicking elsewhere or pressing Escape closes it.
*/
if (!customElements.get('look-hotspots')) {
  customElements.define(
    'look-hotspots',
    class LookHotspots extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-look-hotspot]'));
        this.buttons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.toggle(button);
          });
        });

        this.onDocumentClick = (event) => {
          if (!this.contains(event.target)) this.closeAll();
        };
        document.addEventListener('click', this.onDocumentClick);

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const openButton = this.buttons.find((button) => button.getAttribute('aria-expanded') === 'true');
          this.closeAll();
          openButton?.focus();
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      toggle(button) {
        const wasOpen = button.getAttribute('aria-expanded') === 'true';
        this.closeAll();
        if (wasOpen) return;
        button.setAttribute('aria-expanded', 'true');
        const card = document.getElementById(button.getAttribute('aria-controls'));
        if (card) card.hidden = false;
      }

      closeAll() {
        this.buttons.forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
          const card = document.getElementById(button.getAttribute('aria-controls'));
          if (card) card.hidden = true;
        });
      }
    }
  );
}
